import RepositoryFactory from "../../admin/apis/index";
const menu = RepositoryFactory.CmsMenu;

export default {
  getAllMenu({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await menu.getAllMenu(payload);

        commit("ADD_MENU", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  addOneMenu({}, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        console.log("api called");
        const { data } = await menu.addOneMenu(payload);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
